module.exports = __webpack_public_path__ + "static/media/viva.bca53d34.png";